import React, { useEffect, useState } from "react";
import "./ImportProcessOverlay.css";
import BASE_URL, { API_KEY, FILE_SECRET } from "../../../config";
import Swal from "sweetalert2";
import bootstrapBundleMin from "bootstrap/dist/js/bootstrap.bundle.min";
import { useProcessContext } from "../../context/ProcessContext";
import { IoMdClose } from "react-icons/io";
import CustomDropdown from "../custom_dropdown/CustomDropdown";
import { useRef } from "react";

const ImportProcessOverlay = () => {
  const {
    userData,
    topRightAlert,
    fetchAllActiveDatabase,
    centerAlert,
    fetchAllGroups,
    groups,
    fetchAllProcessData,
    decryptData,
  } = useProcessContext();
  // const [loading, setLoading] = useState(false);
  const [activeDataBases, setActiveDatabases] = useState(null);
  const [fetchedProcess, setFetchedProcess] = useState(null);
  const [isUpdateClicked, setUpdateClicked] = useState(false);
  const [filteredCategory, setFilteredCategory] = useState(null);
  const [filteredGroup, setFilteredGroup] = useState(null);
  const [selectedDatabase, setSelectedDatabase] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const fileInputRef = useRef(null);

  // method for handle data chenges
  const processDataChange = (e) => {
    const { name, value } = e.target;
    if (name === "processName") {
      const regex = /^[a-zA-Z0-9_ ]*$/;

      if (regex.test(value)) {
        setFetchedProcess({
          ...fetchedProcess,
          process: { ...fetchedProcess.process, process_name: value },
        });
      }
    } else if (name === "processDetail") {
      setFetchedProcess({
        ...fetchedProcess,
        process: { ...fetchedProcess.process, process_detail: value },
      });
    } else if (name === "processDatabase") {
      setFetchedProcess({
        ...fetchedProcess,
        database: value,
      });
      setSelectedDatabase(value);
      const configDetail = activeDataBases?.find(
        (config) => config._id === value
      );
      if (configDetail) {
        setFetchedProcess((prevFetchedProcess) => ({
          ...prevFetchedProcess,
          process: {
            ...prevFetchedProcess.process,
            database_obj: value,
            database_url: configDetail.parameter,
            database: `${configDetail.configname} (${configDetail.database})`,
          },
        }));
      }
      // }
      // console.log("selectedDatabase Value::::::: ", selectedDatabase);
    } else if (name === "processGroupCategory") {
      setFetchedProcess({
        ...fetchedProcess,
        group_category: value,
      });
      setSelectedCategory(value);
      setFetchedProcess((prevFetchedProcess) => ({
        ...prevFetchedProcess,
        process: {
          ...prevFetchedProcess.process,
          process_group_category: value,
        },
      }));
    } else if (name === "processGroup") {
      setFetchedProcess({
        ...fetchedProcess,
        group: value,
      });
      setFetchedProcess((prevFetchedProcess) => ({
        ...prevFetchedProcess,
        process: { ...prevFetchedProcess.process, process_group: value },
      }));
    }
  };

  // method for getting active database
  const getData = async () => {
    const activeDatabases = await fetchAllActiveDatabase();
    // console.log("Active Databases:", activeDatabases);
    setActiveDatabases(activeDatabases);
  };

  // fetching active database
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (selectedDatabase) {
      if (groups.length > 0) {
        const grps = groups.filter(
          (group) => group.database_obj === fetchedProcess.database
        );
        const uniqueCategories = Array.from(
          new Set(grps.map((group) => group.category_name))
        ).filter((name) => name);
        setFilteredCategory(uniqueCategories);
        if (selectedCategory) {
          const allFilteredGrpsByCategory = groups.filter(
            (group) =>
              group.database_obj === selectedDatabase &&
              group.category_name === selectedCategory
          );
          setFilteredGroup(allFilteredGrpsByCategory);
        }
      } else {
        fetchAllGroups();
      }
    }
  }, [selectedDatabase, selectedCategory, groups]);

  const handleImport = (event) => {
    const file = event.target.files[0];

    if (file && file.name.endsWith(".oflow")) {
      // Ensure the file has the correct extension

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const encryptedData = e.target.result;
          const decryptedData = decryptData(encryptedData, FILE_SECRET);
          const importedData = JSON.parse(decryptedData);
          // const importedData = decryptedData;
          const forms = JSON.parse(importedData.process_data_form);
          // console.log("imported process:::: ", importedData);
          // console.log(
          //   "All Forms Data:::::: ",
          //   JSON.parse(importedData.process_data_form)
          // );
          const updatedForm = forms.map((form) => {
            if (form.form_builder_id !== null) {
              form.user_id = userData.userid;
              delete form["_id"];
              delete form["__v"];
              return form;
            } else {
              return form;
            }
          });
          console.log("updatedFormData:::: ", updatedForm);
          // setProcessName(importedData.process_name);
          const process = {
            ...importedData,
            user_id: userData.userid,
            process_data_form: JSON.stringify(updatedForm),
            is_module_created: false,
            odoo_checking_status: false,
            is_process_desing_completed: false,
          };
          delete process["_id"];
          delete process["__v"];
          topRightAlert("success", "Process Fetched...");
          // console.log("updated Process at fetch::: ", process);
          // onImport(importedData);
          const importFitData = { process: process, forms: updatedForm };
          setFetchedProcess({
            ...importFitData,
            database: "",
            group_category: "",
          });
        } catch (error) {
          event.target.value = "";
          topRightAlert("error", "Process data could not found.");
          console.error("Error parsing the imported file:", error);
        }
      };

      reader.readAsText(file);
    } else {
      event.target.value = "";
      centerAlert("error", "Please select a valid .oflow file");
      // alert("Please select a valid .oflow file.");
    }
  };

  const handleRemarkHistoryModelNameChange = (allNodeData) => {
    let nodeData = JSON.parse(allNodeData);

    nodeData = nodeData.map((node) => {
      // Check if the form is assigned and selected
      if (
        node.data.form &&
        node.data.isFormSelected &&
        node.data.form.form_builder_id
      ) {
        if (
          node.data.form.formbuilder_data &&
          Array.isArray(node.data.form.formbuilder_data)
        ) {
          // Iterate over each row in formbuilder_data
          let newFormData = [...node.data.form.formbuilder_data];
          newFormData = newFormData.map((row) => {
            // Check if the first object in the row is of type 'remark_history'
            if (row[0].type === "remark_history") {
              const tabs = row[0].tabs;
              if (tabs && Array.isArray(tabs) && tabs.length > 0) {
                const contentArray = tabs[0].content;
                // Check if content has the last object with type 'table'
                if (Array.isArray(contentArray) && contentArray.length > 0) {
                  const lastContentObject =
                    contentArray[contentArray.length - 1][0];

                  if (lastContentObject.type === "table") {
                    // Modify the tableRelatedField key with the new value
                    lastContentObject.tableRelatedField = `x_o2b_${fetchedProcess.process.process_name
                      .trim()
                      .toLowerCase()
                      .replace(/ /g, "_")}_remark_history`;
                    row[0].tabs[0].content[contentArray.length - 1][0] = {
                      ...lastContentObject,
                    };
                  }
                }
              }
            }
            return row;
          });

          // Update the formbuilder_data with the modified data
          node.data.form.formbuilder_data = [...newFormData];
        }
      }

      return node;
    });

    return JSON.stringify(nodeData);
  };
  // old code for table model name change ========================
  // const handleTableModelNameChange = (allNodeData) => {
  //   let nodeData = JSON.parse(allNodeData);

  //   nodeData = nodeData.map((node) => {
  //     // Check if the form is assigned and selected
  //     if (
  //       node.data.form &&
  //       node.data.isFormSelected &&
  //       node.data.form.form_builder_id
  //     ) {
  //       if (
  //         node.data.form.formbuilder_data &&
  //         Array.isArray(node.data.form.formbuilder_data)
  //       ) {
  //         // Iterate over each row in formbuilder_data
  //         const traversFormData = (inputData) => {
  //           const extractFields = (data) => {
  //             if (!Array.isArray(data)) return;

  //             data = data.map((item) => {
  //               if (["tab"].includes(item.type) && Array.isArray(item.tabs)) {
  //                 item = item.tabs.map((tab) => {
  //                   if (Array.isArray(tab.content)) {
  //                     tab = tab.content.map((page) => extractFields(page));
  //                   }
  //                   return tab;
  //                 });
  //               } else if (
  //                 item.type === "group" &&
  //                 Array.isArray(item.fields)
  //               ) {
  //                 item = item.fields.map((groupRow) => extractFields(groupRow));
  //               } else if (
  //                 item.technicalName !== "x_o2b_remark_table" &&
  //                 item.type === "table"
  //               ) {
  //                 item.tableRelatedField = `x_o2b_${fetchedProcess.process.process_name
  //                   .trim()
  //                   .toLowerCase()
  //                   .replace(/ /g, "_")}_${item.tableRelatedField}`;
  //               }
  //               return item;
  //             });
  //             return data;
  //           };

  //           return inputData?.map(extractFields);
  //         };
  //         let newFormData = [...node.data.form.formbuilder_data];

  //         newFormData = traversFormData(newFormData);

  //         // Update the formbuilder_data with the modified data
  //         node.data.form.formbuilder_data = [...newFormData];
  //       }
  //     }

  //     return node;
  //   });

  //   return JSON.stringify(nodeData);
  // };
  // new old  code for table model name change ========================
  // const handleTableModelNameChange = (allNodeData) => {
  //   const nodeData = JSON.parse(allNodeData);

  //   const updatedNodes = nodeData.map((node) => {
  //     if (
  //       node.data.form &&
  //       node.data.isFormSelected &&
  //       Array.isArray(node.data.form.formbuilder_data)
  //     ) {
  //       // Recursive function to process fields
  //       const processFields = (fields) => {
  //         return fields.map((field) => {
  //           if (field.type === "tab" && Array.isArray(field.tabs)) {
  //             // Process tabs
  //             field.tabs = field.tabs.map((tab) => {
  //               if (Array.isArray(tab.content)) {
  //                 tab.content = processFields(tab.content);
  //               }
  //               return tab;
  //             });
  //           } else if (field.type === "group" && Array.isArray(field.fields)) {
  //             // Process grouped fields
  //             field.fields = processFields(field.fields);
  //           } else if (
  //             field.type === "table" &&
  //             field.technicalName !== "x_o2b_remark_table"
  //           ) {
  //             // Modify table-related fields
  //             field.tableRelatedField = `x_o2b_${fetchedProcess.process.process_name
  //               .trim()
  //               .toLowerCase()
  //               .replace(/ /g, "_")}_${field.tableRelatedField}`;
  //           }
  //           return field;
  //         });
  //       };

  //       // Update the formbuilder_data
  //       // node.data.form.formbuilder_data = processFields(
  //       //   node.data.form.formbuilder_data
  //       // );
  //       node.data.form.formbuilder_data =
  //         node.data.form.formbuilder_data.map(processFields);
  //     }

  //     return node;
  //   });

  //   return JSON.stringify(updatedNodes);
  // };
  // ==========================================================
  const handleTableModelNameChange = (allNodeData) => {
    let nodeData = JSON.parse(allNodeData);
    const totalFieldNames = [];

    nodeData = nodeData.map((node) => {
      if (
        node.data.form &&
        node.data.isFormSelected &&
        Array.isArray(node.data.form.formbuilder_data)
      ) {
        // Recursive function to process fields
        const processFields = (fields) => {
          return fields.map((field) => {
            if (field.type === "tab" && Array.isArray(field.tabs)) {
              // Process tabs
              field.tabs = field.tabs.map((tab) => {
                if (Array.isArray(tab.content)) {
                  tab.content = processFields(tab.content);
                }
                return tab;
              });
            } else if (field.type === "group" && Array.isArray(field.fields)) {
              // Process grouped fields
              field.fields = processFields(field.fields);
            } else if (
              field.type === "table" &&
              field.technicalName !== "x_o2b_remark_table"
            ) {
              // Modify table-related fields
              const oldFieldName = `x_total_${field.tableRelatedField}`;
              field.tableRelatedField = `x_o2b_${fetchedProcess.process.process_name
                .trim()
                .toLowerCase()
                .replace(/ /g, "_")}_${field.tableRelatedField}`;
              const newFieldName = `x_total_${field.tableRelatedField}`;

              totalFieldNames.push({
                old_name: oldFieldName,
                new_name: newFieldName,
              });
            }
            return field;
          });
        };

        // Update the formbuilder_data
        node.data.form.formbuilder_data =
          node.data.form.formbuilder_data.map(processFields);
      }

      return node;
    });
    // console.log("totalFieldNames:::---", totalFieldNames);
    let newNodeData = JSON.stringify(nodeData);
    totalFieldNames?.forEach((name) => {
      newNodeData = updateDecisionConditionSet(
        newNodeData,
        name.old_name,
        name.new_name
      );
    });

    return newNodeData;
  };
  // method for updating condition when there is total field
  // const handleActivityUpdateDecisionConditionSet = (fieldTechnicalName, updatedValue) => {
  //   setNodes((prevNodes) =>
  //     prevNodes.map((node) => {
  //       if (node.type === "decision" && Array.isArray(node.data.next_name)) {
  //         const updatedNextSteps = node.data.next_name.map((step) => {
  //           if (Array.isArray(step.condition)) {
  //             const updatedConditions = step.condition.map((condition) => {
  //               if (Array.isArray(condition)) {
  //                 return condition.map((cond) =>
  //                   cond === fieldTechnicalName ? updatedValue : cond
  //                 );
  //               }
  //               return condition === fieldTechnicalName ? updatedValue : condition;
  //             });

  //             return {
  //               ...step,
  //               condition: updatedConditions,
  //             };
  //           }
  //           return step;
  //         });

  //         return {
  //           ...node,
  //           data: {
  //             ...node.data,
  //             next_name: updatedNextSteps,
  //           },
  //         };
  //       }
  //       return node;
  //     })
  //   );
  // };
  // Method to update decision condition set based on old and new field names
  const updateDecisionConditionSet = (
    allNodeData,
    oldFieldName,
    newFieldName
  ) => {
    const nodeData = JSON.parse(allNodeData);
    // console.log("Inside update condition set method ==================");

    const updatedNodes = nodeData.map((node) => {
      if (node.type === "decision" && Array.isArray(node.data.next_name)) {
        // console.log("Decison Node:::::");
        // console.log("old next-step: ", node.data.next_name);
        const updatedNextSteps = node.data.next_name.map((step) => {
          // console.log("Iterating next name----");
          if (Array.isArray(step.condition)) {
            // console.log("Iterating step.condition----");
            const updatedConditions = step.condition.map((condition) => {
              if (Array.isArray(condition)) {
                // console.log("Iterating last old condition----", condition);
                condition = condition.map((cond) =>
                  cond === oldFieldName ? newFieldName : cond
                );
                // console.log("Iterating new condition----", condition);
              }
              return condition;
            });

            // return {
            //   ...step,
            //   condition: updatedConditions,
            // };
            step.condition = updatedConditions;
          }
          // console.log("step.condition block over----");
          return step;
        });

        // console.log("new next-step: ", node.data.next_name);

        return {
          ...node,
          data: {
            ...node.data,
            next_name: updatedNextSteps,
          },
        };
      }
      return node;
    });

    return JSON.stringify(updatedNodes);
  };

  // =============================================================

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      fetchedProcess === null ||
      fetchedProcess.database === "" ||
      fetchedProcess.database === null
    ) {
      return centerAlert("error", "Hutch field is mandatory to fill");
    }
    if (
      fetchedProcess === null ||
      fetchedProcess.group_category === "" ||
      fetchedProcess.group_category === null
    ) {
      return centerAlert("error", "Group Category field is mandatory to fill");
    }

    // console.log("imported process data: ", JSON.stringify(fetchedProcess));
    try {
      const remarkUpdatedData = handleRemarkHistoryModelNameChange(
        fetchedProcess.process.process_data_flow.nodesData
      );
      const allNodeJsonData = handleTableModelNameChange(remarkUpdatedData);
      // console.log("allNodeJsonData::: ", allNodeJsonData);

      const mainData = {
        process: {
          ...fetchedProcess.process,
          process_name: fetchedProcess.process.process_name?.trim(),
          process_data_flow: {
            ...fetchedProcess.process.process_data_flow,
            nodesData: allNodeJsonData,
          },
        },
        forms: fetchedProcess.forms,
        database: fetchedProcess.database,
        group_category: fetchedProcess.group_category,
        group: fetchedProcess.group,
      };
      // console.log("mainData: ", mainData);
      const payload = {
        data: { ...mainData },
        // data: { ...fetchedProcess },
        api_key: API_KEY,
        user_id: userData.userid,
      };
      // console.log("payload for import: ", payload);
      // console.log("payload json for import: ", JSON.stringify(payload));
      const response = await fetch(`${BASE_URL}/process/import/module`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (response.ok) {
        // console.log("response for import: ", data);
        fetchAllProcessData();
        topRightAlert("success", data.message);
        setFetchedProcess(null);
        setSelectedDatabase(null);
        setSelectedCategory(null);
        // Reset the file input field
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        const modalElement = document.getElementById("processImportModal");
        const modalInstance =
          bootstrapBundleMin.Modal.getInstance(modalElement);
        modalInstance.hide();
      } else {
        // console.log("response for import: ", data);
        centerAlert("error", data.message);
      }
    } catch (error) {
      centerAlert("error", error);
    }
  };
  // console.log("fetched process:::: ", fetchedProcess);
  // console.log("selectedDatabase:::: ", selectedDatabase);
  // console.log("groups:::: ", groups);
  // console.log("filteredGroup:::: ", filteredGroup);
  return (
    <div
      className="modal fade"
      id="processImportModal"
      tabIndex={-1}
      data-bs-backdrop="static"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              Import process
            </h1>
            <button
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{
                position: "absolute",
                right: "20px",
                fontSize: "25px",
                color: "white",
              }}
            >
              <IoMdClose />
            </button>
          </div>
          <form method="post" onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="importProcessModalForm">
                <div className="importProcessModalForm_inputField">
                  <label htmlFor="formFile">Upload file</label>
                  <input
                    type="file"
                    id="formFile"
                    className="form-control"
                    placeholder="upload process icon"
                    name="process_icon"
                    onChange={handleImport}
                    accept=".oflow"
                    required
                    ref={fileInputRef}
                  />
                  <span>*only .oflow extension is accepted.</span>
                </div>
                {fetchedProcess && (
                  <>
                    {isUpdateClicked ? (
                      <>
                        <div className="importProcessModalForm_inputField">
                          <label htmlFor="processName">Process Name</label>
                          <input
                            type="text"
                            id="processName"
                            className="form-control"
                            placeholder="enter process name"
                            value={fetchedProcess?.process?.process_name}
                            name="processName"
                            onChange={processDataChange}
                            required
                          />
                        </div>
                        <div className="importProcessModalForm_inputField">
                          <label htmlFor="processDetail">Process Detail</label>
                          <input
                            type="text"
                            id="processDetail"
                            className="form-control"
                            placeholder="enter process detail"
                            value={fetchedProcess?.process?.process_detail}
                            name="processDetail"
                            onChange={processDataChange}
                            required
                          />
                        </div>
                        {/* <p>No. of Form: {fetchedProcess?.forms?.length}</p> */}
                        <button
                          className="btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            setUpdateClicked(!isUpdateClicked);
                          }}
                        >
                          Update
                        </button>
                      </>
                    ) : (
                      <>
                        {/* ============================================================ */}

                        <div className="importProcessModalForm_inputField">
                          <label htmlFor="processDatabase">
                            Hutch (database)*
                          </label>
                          <CustomDropdown
                            name="processDatabase"
                            defaultValue={fetchedProcess.database || null}
                            options={activeDataBases?.map((db) => {
                              return {
                                value: db._id,
                                label: `${db.configname} (${db.database})`,
                              };
                            })}
                            onChange={(event) => processDataChange(event)}
                            width={"95%"}
                            height={"35px"}
                            border="1px solid gray"
                          />
                        </div>
                        <div className="importProcessModalForm_inputField">
                          <label htmlFor="processGroup">
                            User Role Section*
                          </label>
                          <CustomDropdown
                            name="processGroupCategory"
                            defaultValue={
                              fetchedProcess?.group_category || null
                            }
                            options={filteredCategory?.map((group) => {
                              return {
                                value: group,
                                label: group,
                              };
                            })}
                            onChange={(event) => processDataChange(event)}
                            width={"95%"}
                            height={"35px"}
                            border="1px solid gray"
                          />
                        </div>
                        <div className="importProcessModalForm_inputField">
                          <label htmlFor="processGroup">User Access</label>
                          <CustomDropdown
                            name="processGroup"
                            defaultValue={fetchedProcess?.group || null}
                            options={filteredGroup?.map((group) => {
                              return {
                                value: `base.${group.group_internal}`,
                                label: group.group_name,
                              };
                            })}
                            onChange={(event) => processDataChange(event)}
                            width={"95%"}
                            height={"35px"}
                            border="1px solid gray"
                          />
                        </div>

                        {/* ============================================================ */}
                        <div className="importProcessModalForm_inputField_fetch">
                          <label htmlFor="processName">Process Name</label>
                          <span>:</span>
                          <span style={{ width: "100%" }}>
                            {fetchedProcess?.process?.process_name}
                          </span>
                        </div>
                        <div className="importProcessModalForm_inputField_fetch">
                          <label htmlFor="processDetail">Process Detail</label>
                          <span>:</span>
                          <p>{fetchedProcess?.process?.process_detail}</p>
                        </div>
                        <div className="importProcessModalForm_inputField_fetch">
                          <label htmlFor="processDetail">No. of Forms:</label>
                          <span>:</span>
                          <span style={{ width: "100%" }}>
                            {fetchedProcess?.forms?.length}
                          </span>
                        </div>
                        <button
                          className="btn modal_process_update_button"
                          onClick={(e) => {
                            e.preventDefault();
                            setUpdateClicked(!isUpdateClicked);
                          }}
                        >
                          Update Process Data
                        </button>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" className="btn modal_save_button">
                Import
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ImportProcessOverlay;
